import { render, staticRenderFns } from "./LunchTableSpacer.vue?vue&type=template&id=0e512156&"
import script from "./LunchTableSpacer.vue?vue&type=script&lang=js&"
export * from "./LunchTableSpacer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports